import { render, staticRenderFns } from "./dialog--set-status.vue?vue&type=template&id=7ff18292&"
import script from "./dialog--set-status.vue?vue&type=script&lang=js&"
export * from "./dialog--set-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports